import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, A11y } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".gallery-swiper").forEach((element) => {
    new Swiper(element, {
      modules: [Navigation, Pagination, Autoplay, A11y],
      slidesPerView: 1.4,
      breakpoints: {
        480: {
          slidesPerView: 2,
        },
        960: {
          slidesPerView: 3.2,
        },
        1312: {
          slidesPerView: 4,
        },
      },
      spaceBetween: 0,
      centeredSlides: true,
      simulateTouch: false,
      watchOverflow: false,
      navigation: {
        enabled: element.dataset.navigation == "1",
        prevEl: element.closest(".swiper-parent").querySelector(".swiper-navigation .prev"),
        nextEl: element.closest(".swiper-parent").querySelector(".swiper-navigation .next"),
      },
      loop: element.dataset.loop == "1",
      autoplay:
        element.dataset.autoplay == "1"
        ? {
          delay: parseFloat(element.dataset.autoplayDelay) * 1000,
          pauseOnMouseEnter: true,
        }
        : false,
      on: {
        beforeInit: (swiper) => {
          if(swiper.el.dataset.loop != "1") return;

          const wrapper = swiper.el.querySelector(".swiper-wrapper");
          const slides = Array.from(wrapper.children);

          if (slides.length > 5 || slides.length == 0) return;

          const minimumQuantityToClone = 5 - slides.length;
          let cloneCount = 0;

          do {
            for (let i = 0; i < slides.length; i++) {
              const clone = slides[i].cloneNode(true);
              clone.classList.add("swiper-slide-duplicate");
              wrapper.appendChild(clone);
              cloneCount++;
            }
          } while (cloneCount < minimumQuantityToClone);
        },
      },
    });
  });
});
